import { defineStore } from 'pinia';
import LoginService from '../../../Services/LoginService';
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { defineComponent, ref, computed, onMounted, watch, onUpdated } from 'vue';

export interface State {
    PoIdList: any[]
}


export const useReOrderStore = defineStore({
    id: 'ReOrderStore',

    state: (): State => ({
        PoIdList: [],
    }),

    getters: {
    },
    actions: {
        isReset() {
        },
        isResetall() {
        },
        isResetBool() {
        },
    }
});
